<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="姓名/代理ID">
            <template slot="label">
              <I18Lang id="proxyproxy5" defaultText="姓名/代理ID" />
            </template>
            <el-input style="width:200px" :placeholder="$t('proxyproxy6')" v-model="queryForm.username"></el-input>
          </el-form-item>
          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>
        </el-form>
        <div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </div>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column label="姓名">
            <template slot="header">
              <I18Lang id="proxyproxy10" defaultText="姓名" />
            </template>
            <template slot-scope="{row}" v-if="row.agent">
              {{ row.agent.username }}
            </template>
          </el-table-column>
          <el-table-column label="代理ID">
            <template slot="header">
              <I18Lang id="proxyproxy22" defaultText="代理ID" />
            </template>
            <template slot-scope="{row}" v-if="row.agent">
              {{ row.agent.account_id }}
            </template>
          </el-table-column>
          <el-table-column label="上级代理ID">
            <template slot="header">
              <I18Lang id="proxyproxy23" defaultText="上级代理ID" />
            </template>
            <template slot-scope="{row}" v-if="row.parent">
              {{ row.parent.account_id }}
            </template>
          </el-table-column>
          <el-table-column label="代理名下用户数" prop="user_num">
            <template slot="header">
              <I18Lang id="proxyproxy48" defaultText="代理名下用户数" />
            </template>
          </el-table-column>
          <el-table-column label="代理名下入金($)" prop="recharge_amount">
            <template slot="header">
              <I18Lang id="proxyproxy49" defaultText="代理名下入金($)" />
            </template>
          </el-table-column>
          <el-table-column label="代理名下出金($)" prop="withdrawal_amount">
            <template slot="header">
              <I18Lang id="proxyproxy50" defaultText="代理名下出金($)" />
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('proxyproxy51', { n: 'MEQ' })}`" prop="trade_amount">
          </el-table-column>
          <el-table-column :label="`${$t('proxyproxy52', { n: 'MEQ' })}`" prop="commission">
          </el-table-column>
          <!--<el-table-column :label="`${$t('proxyproxy53', { n: 'MEQ' })}`" prop="interest">
          </el-table-column>-->
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="total, prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'
export default {
  name: 'record',
  data () {
    return {
      queryForm: {
        username: '',
        page: 1,
        size: 10
      },
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/performanceReport?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http.post('/api/agent/performanceReport', this.queryForm).then(result => {
        console.log('result', result)
        this.tableData = result
      })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_date = val ? val[0] : ''
      this.queryForm.end_date = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss"></style>
